
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { SUPABASE_URL } from '@/config/environment';

// Use environment variable or fall back to the project ID
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InF6Y2d0dmNpZmV2bGhtcm9iZ2lhIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mzg2ODE1MDcsImV4cCI6MjA1NDI1NzUwN30.FifTOZOIEIDLSRYQ99bBUFOojqILwbRQU2cBPxpcEaQ";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);
